import { render, staticRenderFns } from "./carousel-photos-block.vue?vue&type=template&id=70258a8a&"
import script from "./carousel-photos-block.vue?vue&type=script&lang=js&"
export * from "./carousel-photos-block.vue?vue&type=script&lang=js&"
import style0 from "./carousel-photos-block.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports